var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#222939",
    fillRule: "evenodd",
    d: "M3.315 7.858L.133 4.441c-.177-.187-.177-.494 0-.683l.643-.684c.177-.188.465-.188.642 0l2.219 2.393L8.58.141c.177-.188.466-.188.643 0l.643.683c.177.188.177.496 0 .683l-5.91 6.35c-.177.189-.465.189-.642 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon-check.8405cd6b08f3b4f354572c6a5be4fa1d.svg";
export { ForwardRef as ReactComponent };